var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2656 4.92188H2.73438C2.29941 4.92238 1.8824 5.0954 1.57484 5.40296C1.26727 5.71053 1.09426 6.12753 1.09375 6.5625V28.4375C1.09426 28.8725 1.26727 29.2895 1.57484 29.597C1.8824 29.9046 2.29941 30.0776 2.73438 30.0781H32.2656C32.7006 30.0776 33.1176 29.9046 33.4252 29.597C33.7327 29.2895 33.9057 28.8725 33.9062 28.4375V6.5625C33.9057 6.12753 33.7327 5.71053 33.4252 5.40296C33.1176 5.0954 32.7006 4.92238 32.2656 4.92188ZM31.7188 7.10938V11.4844H3.28125V7.10938H31.7188ZM3.28125 27.8906V15.8594H31.7188V27.8906H3.28125Z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 21.3281H10.3906V23.5156H6.01562V21.3281ZM12.5781 21.3281H16.9531V23.5156H12.5781V21.3281Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.69f48b170f7159f016f1e6b7a941d79a.svg";
export { ForwardRef as ReactComponent };